import { UserBankAccount } from 'src/redux/types';
import { call } from '../@';

export type GetUserBankAccountsResponse = UserBankAccount[];

export default async function getUserBankAccounts() {
	return await call('bankAccounts-get', {});
}
